// Getting started (F7): a quiet checklist on Home until the studio has made a shot, invited someone, asked for a
// sign-off and connected a Claude. Not a loud moment: a plain card, neutral squares, one text button to hide it.
import { useEffect, useState } from "react";
import { safeGet, safeSet } from "../../auth.ts";
import {
  hideStart,
  isStartHidden,
  type Onboarding,
  showStart,
  startItems,
  startProgress,
} from "../../data/gettingStarted.ts";
import { useApp } from "../app.ts";
import { ImportEntryCard } from "../import/ImportEntry.tsx";
import { StatusSquare } from "../StatusSquare.tsx";
import "./getting-started.css";

const store = { get: safeGet, set: safeSet };

export function GettingStarted() {
  const { api, ws, role } = useApp();
  const [onboarding, setOnboarding] = useState<Onboarding | null>(null);
  const [hidden, setHidden] = useState(() => isStartHidden(store, ws));
  useEffect(() => setHidden(isStartHidden(store, ws)), [ws]);
  useEffect(() => {
    let live = true;
    setOnboarding(null);
    api.request<Onboarding>("GET", `/workspaces/${ws}/onboarding`).then(
      (o) => live && setOnboarding(o),
      // the checklist is a convenience: if it cannot be read, Home goes on without it
      () => undefined,
    );
    return () => {
      live = false;
    };
  }, [api, ws]);
  if (!showStart(onboarding, role, hidden) || !onboarding) return null;
  const items = startItems(onboarding);
  return (
    <section className="k-card gs" aria-labelledby="gs-title">
      <div className="gs-head">
        <h2 id="gs-title">Getting started</h2>
        <span className="muted">{startProgress(items)}</span>
        <button
          type="button"
          className="k-btn k-text k-sm"
          onClick={() => {
            hideStart(store, ws);
            setHidden(true);
          }}
        >
          Hide
        </button>
      </div>
      <ul className="gs-list">
        {items.map((i) => (
          <li key={i.id} className={i.done ? "gs-done" : undefined}>
            <StatusSquare
              state={i.done ? "signed" : "open"}
              size={12}
              label={i.done ? "Done" : "Not done yet"}
            />
            <a className="gs-link" href={i.href}>
              <span className="gs-label">{i.label}</span>
              <span className="gs-hint">{i.hint}</span>
            </a>
          </li>
        ))}
      </ul>
      <ImportEntryCard compact />
    </section>
  );
}
